import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { HBox, VBox } from '../../../../components/Box';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { selectVehicle } from '../../../Vehicles/selectors';
import { Cell as ActionCell } from '../Cell';
import { finalizeAndExportInvoice } from '../../../Invoices/actions';
import { SideModal } from '../../components/SideModal';
import { VehicleHeaderV2Design } from '../../../Vehicles/components/VehicleHeaderV2Design';
import { FINCompanyCard } from '../../../Companies/components/FinCompanyCard';
import { FIN_facturerenModalBody } from '../../components/FinFacturerenModalBody/FinFacturerenModalBody';
import { FIN_facturerenModal } from '../../components/FinFacturerenEditInvoiceModal/FinFacturerenModal';
import { InvoiceFinalizationSection } from '../../components/InvoiceFinalizationSection';
import { DeleteInvoice } from '../../../Invoices/components/DeleteInvoice/DeleteInvoice';
import { selectCompany } from '../../../Companies/selectors';
import { REQUEST_COMPANY, REQUEST_VIES_CHECK } from '../../../Companies/constants';
import { checkVies } from '../../../Companies/actions';
import { selectVatCodes } from '../../../Invoices/selectors';
import { getVatCodes, fetchInvoice } from '../../../Invoices/actions';
import {
  GET_CURRENT_REST_BPM,
  FINALIZE_EXPORT_MAIL_INVOICE,
  REQUEST_INVOICE,
  REQUEST_INVOICE_EMAIL,
  REQUEST_EXACT_EXPORT_INVOICE,
} from '../../../Invoices/constants';
import { ViesCheckPrompt } from '../../../Invoices/components/ViesCheckPrompt';
import { toggleKanbanCompanyModal } from '../../actions';
import { getCurrentRestBpm, updateInvoiceOutgoingBpm } from '../../../Invoices/actions';
import { selectKanbanCompanyToggle } from '../../selectors';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import cn from 'classnames';
import styles from './FIN.module.css';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import { Label } from '../../../Vehicles/components/VehicleCounterLabel';

import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { getRemarkType } from '../helpers/getRemarkType';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { selectUserId, selectWork,selectWorks } from '../../../Api/selectors';

const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};

const TASK_REMARK_TYPE = 'Verkoop_verwerken';


const Container = styled.div`
  h2 {
    font-size: 16px;
    text-transform: uppercase;
  }

  .pane {
    padding: 24px 12px;

    .fields {
      margin-top: 24px;
    }

    h3 {
      margin-bottom: 12px;
    }

    h4 {
      margin-top: 24px;
      font-size: 20px;
    }
  }
`;

const STATE = {
  approve: false,
};

/* eslint-disable react/prefer-stateless-function */
class IDWEFINfactureren_combine_akkoordComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }


  componentDidMount() {
    this.props.fetchInvoice(result => {
      this.setState({ invoice: result });
    });
    this.props.getCode();
  }

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  toggle() {
    return this.props.toggleModal(this.vehicle?.id);
  }


  get vehicleSubject() {
    return this.state.invoice?.invoiceSubjects?.find(s => s.type == 'vehicle');
  }

  get vatCodes() {
    return this.props.vatCodes ?? [];
  }


  getVatCodeLabel(code) {
    return this.vatCodes?.filter(vatCode => vatCode.code == code);
  } 

  
  applyDisable() {
    return this.props.workCompany || this.props.workInvoice || this.props.workMailing;
  }



  render() {
    const vehicle = this.vehicle;
    return (
      <ActionCell className={styles.cell}>
        <Container>
          {this.props.isShowModal?.isShow && this.props.isShowModal?.entityId == vehicle?.id && (
            <SideModal className={styles.sideContainer}>
              <div className={styles.buttonClose}>
                <button
                  onClick={this.toggle.bind(this)}
                  type="button"
                  className={cn('btn-close', styles.buttonCl)}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <WithVehicle vehicle_id={this.vehicle.id} loader>
                <VBox>
                  <h2>{this.props.action?.functionName}</h2>
                  <VBox right>
                    <div className={styles.boxButtons}>
                      <ButtonComponent
                        style={'ButtonSoftPrimary'}
                        onClick={this.tofn(`/invoices/${this.vehicle.outgoing_invoice}`)}
                      >
                        <View /> {this.lbl('vehicle.details.view_outgoingInvoice')}
                      </ButtonComponent>



                      {this.props.workFinalize ? (
  <Loader small />
) : (
  <>
    {/* Check waarschuwingen */}
    {(() => {
      const vatDescription = this.getVatCodeLabel(
        this.vehicleSubject?.subjectVat?.code
      )[0]?.description?.toLowerCase();

      const taxType = this.props.vehicle?.tax_type?.toLowerCase();

      const caseA = vatDescription?.includes('btw') && taxType !== 'btw';
      const caseB = taxType === 'btw' && !vatDescription?.includes('btw');

      if (caseA) {
        return (
          <div style={{ color: 'red', marginTop: '8px' }}>
            ⚠️ Let op: Factuur is BTW maar het voertuig staat niet als BTW voertuig!
          </div>
        );
      }

      if (caseB) {
        return (
          <div style={{ color: 'red', marginTop: '8px' }}>
            ⚠️ Let op: Factuur staat als MARGE maar voertuig is geen margevoertuig!
          </div>
        );
      }

      // Alleen als geen waarschuwing, laat section zien
      return (
        <InvoiceFinalizationSection
          className={styles.buttonInvoiceFinalizationSection}
          invoice_id={this.vehicle?.outgoing_invoice}
          FIN_kanban_modal
        />
      );
    })()}
  </>
)}
                      <DeleteInvoice className={styles.buttonDeleteInvoice} invoiceId={this.vehicle?.outgoing_invoice} />
                    </div>

                    <VehicleHeaderV2Design wide vehicle={this.vehicle} />
                    <FINCompanyCard companyId={this.vehicle?.invoice_outgoing_company_id} />
                  </VBox>
                  <FIN_facturerenModalBody invoiceId={this.vehicle?.outgoing_invoice} />
                  <FIN_facturerenModal
                    functionName={this.props.action?.functionName}
                    invoiceId={this.vehicle?.outgoing_invoice}
                    vehicle={this.vehicle}
                  />
                </VBox>
                <div className="pane"></div>
              </WithVehicle>
            </SideModal>
          )}
           <VehicleHeader vehicle={vehicle} loadSingleRes={this.props.loadSingleRes} />

           {!vehicle.action_ws1_1_labels_done && (env.clientId === AppClientId.INDEWAL || env.clientId === AppClientId.IDWLEASE) && (
            <span style={{ color: 'red' }}>&nbsp; LET OP: niet gelabeled</span>
          )}
            {!vehicle?.action_ws2_interior_inspection_done && env.clientId === AppClientId.INDEWAL && (
            <span style={{ color: 'red' }}>&nbsp; LET OP: niet geinspecteerd</span>
          )}
          <Label count={vehicle?.doorlooptijd_verkoopfactuur_counter} ranges={ranges}>
            {vehicle?.doorlooptijd_verkoopfactuur_counter || '0'}
          </Label>

          <CellButtons>
          {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
               <div className={styles.cellButtonContainer}>
                <CellButton onClick={this.toggle.bind(this)}>
                  <View />
                </CellButton>
              </div>
              </>
            )}
          </CellButtons>
        </Container>
      </ActionCell>
    );
  }
}

IDWEFINfactureren_combine_akkoordComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle?.id}`]),
    workFinalize: selectWork(REQUEST_EXACT_EXPORT_INVOICE),
    workCompany: selectWork(REQUEST_COMPANY),
    workInvoice: selectWork(REQUEST_INVOICE),
    workMailing: selectWork(`${REQUEST_INVOICE_EMAIL}-${ownProps.cell.vehicle?.outgoing_invoice}`),
    workBpm: selectWork(GET_CURRENT_REST_BPM),
    workFinalizeAndExport: selectWork(FINALIZE_EXPORT_MAIL_INVOICE),
    workViesCheck: selectWork(REQUEST_VIES_CHECK),
    vehicle: selectVehicle(ownProps.cell.vehicle?.id),
    company: selectCompany(ownProps.cell.vehicle?.invoice_outgoing_company_id),
    isShowModal: selectKanbanCompanyToggle(),
    vatCodes: selectVatCodes(),
    loggedInUserId: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    toggleModal(vehicleId) {
      dispatch(toggleKanbanCompanyModal(vehicleId));
    },
    fetchInvoice(callback) {
      dispatch(fetchInvoice(ownProps.cell.vehicle?.outgoing_invoice, callback, { isUniqueGate: true }));
    },
    getCurrentRestBpm(vehicleId) {
      dispatch(getCurrentRestBpm(vehicleId));
    },
    updateInvoiceOutgoingBpm(invoiceId, value, callback) {
      dispatch(updateInvoiceOutgoingBpm(invoiceId, value, callback));
    },
     getCode() {
          dispatch(getVatCodes());
        },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const IDWEFINfactureren_combine_akkoord = compose(withConnect, withRouter)(IDWEFINfactureren_combine_akkoordComp);
